import { allFetch } from "../Domain";

/**
 * @description 公佈欄
 */
export const Bulletin = (() => {
    /**
     * @description 公佈欄查詢(後台編輯用)
     */
    const BulletinEditSearch = async function (obj = {
        subject: '',
        valid_date_start: '',
        valid_date_end: '',
        invalid_date_start: '',
        invalid_date_end: '',
        is_top: '',
        visible: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('Bulletin/BulletinEditSearch', obj);
    }
    /**
     * @description 公佈欄新建
     */
    const BulletinCreate = async function (obj = {
        subject: '',
        content: '',
        valid_date: '',
        invalid_date: '',
        is_top: 'N'
    }) {
        return await allFetch('Bulletin/BulletinCreate', obj);
    }
    /**
     * @description 公佈欄細項
     */
    const BulletinDetail = async function (obj = {
        bulletin_id: ''
    }) {
        return await allFetch('Bulletin/BulletinDetail', obj);
    }
    /**
     * @description 公佈欄修改
     */
    const BulletinUpdate = async function (obj = {
        bulletin_id: '',
        subject: '',
        content: '',
        valid_date: '',
        invalid_date: '',
        is_top: '',
        visible: ''
    }) {
        return await allFetch('Bulletin/BulletinUpdate', obj);
    }
    /**
     * @description 公佈欄查詢(公告區)
     */
    const BulletinSearch = async function (obj) {
        return await allFetch('Bulletin/BulletinSearch', obj);
    }
    /**
    * @description 公佈欄已讀 (同意)
    */
    const BulletinRead = async function (obj = {
        bulletin_ids: [],
    }) {
        return await allFetch('Bulletin/BulletinRead', obj);
    }

    /**
    * @description 公佈欄已讀 (同意)
    */
    const BulletinReadSearch = async function (obj = {
        bulletin_id: '',
    }) {
        return await allFetch('Bulletin/BulletinReadSearch', obj);
    }
    return {
        BulletinEditSearch,
        BulletinCreate,
        BulletinDetail,
        BulletinUpdate,
        BulletinSearch,
        BulletinRead,
        BulletinReadSearch
    }
})();
